const applicationID = 'NKJP6H87O2';
const apiKey = '4a654cd89ec0665aecf805083e4c76d2';
const productIndex = 'mdm_catalog_fr_fr';
const categoryIndex = 'mdm_suggestions';
export { applicationID, apiKey, productIndex, categoryIndex };